import { render, staticRenderFns } from "./image-collection-sliding-overlays.vue?vue&type=template&id=118cf1ee&scoped=true&"
import script from "./image-collection-sliding-overlays.vue?vue&type=script&lang=js&"
export * from "./image-collection-sliding-overlays.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=118cf1ee&scoped=true&lang=css&"
import style1 from "./image-collection-sliding-overlays.vue?vue&type=style&index=1&id=118cf1ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118cf1ee",
  null
  
)

export default component.exports